export const data1 = [
  {
    id: "1",
    title: "安联保险集团（Allianz SE）",
    value: "53.33%",
  },
  {
    id: "2",
    title: "北京京东叁佰陆拾度电子商务有限公司",
    value: "33%",
  },
  {
    id: "3",
    title: "中原信达知识产权代理有限责任公司",
    value: "9.4%",
  },
];
